module.exports = __webpack_public_path__ + "img/6.107cd6a0.jpg";